module.exports = __webpack_public_path__ + "static/media/krakenwavebg.6c88eb16.svg";